// ------------------------------------
// Constants
// ------------------------------------
import axios from 'axios'
import { protocol, origin, getHeaders } from './addons'
import Notifications from 'react-notification-system-redux'
import {
  addArticleSuccess,
  addArticleError,
  delArticleSuccess,
  delArticleError
} from './toasts'
export const GET_ARTICLES = 'GET_ARTICLES'
export const GET_ARTICLE = 'GET_ARTICLE'
export const UPDATE_TABLE_ARTICLE = 'UPDATE_TABLE_ARTICLE'

// ------------------------------------
// Actions
// ------------------------------------
const getArticlesAction = (data = undefined) => {
  return {
    type: GET_ARTICLES,
    data: data
  }
}

const getArticleAction = (data = undefined) => {
  return {
    type: GET_ARTICLE,
    data: data
  }
}

const updateArticleAction = (data = undefined) => {
  return {
    type: UPDATE_TABLE_ARTICLE,
    data: data
  }
}

export const getArticles = (queries = '') => {
    return (dispatch) => {
      return new Promise((resolve) => {
        return new Promise((resolve) => {
          axios.post(`${protocol}//${origin}/api/articles/search`, queries)
            .then((json) => {
              dispatch(getArticlesAction(json.data))
              resolve()
            })
            .catch((error) => {
              console.log(error)
              resolve()
            })
        })
      })
    }
  }

  export const getArticle = (id) => {
    return (dispatch) => {
      return new Promise((resolve) => {
        return new Promise((resolve) => {
          axios.get(`${protocol}//${origin}/api/articles/${id}`)
            .then((json) => {
              dispatch(getArticleAction(json.data))
              resolve()
            })
            .catch((error) => {
              console.log(error)
              resolve()
            })
        })
      })
    }
  }

  export const addArticle = (data) => {
    return (dispatch) => {
      return new Promise((resolve) => {
        axios.post(`${protocol}//${origin}/api/articles`, data, getHeaders())
          .then((json) => {
            dispatch(updateArticleAction())
            dispatch(Notifications.success(addArticleSuccess))
            resolve()
          })
          .catch((error) => {
            console.log(error)
            dispatch(Notifications.error(addArticleError))
            resolve()
          })
      })
    }
  }

  export const updateArticle = (data, id) => {
    return (dispatch) => {
      return new Promise((resolve) => {
        axios.put(`${protocol}//${origin}/api/articles/${id}`, data, getHeaders())
          .then((json) => {
            dispatch(Notifications.success(addArticleSuccess))
            resolve()
          })
          .catch((error) => {
            console.log(error)
            dispatch(Notifications.error(addArticleError))
            resolve()
          })
      })
    }
  }

  export const deleteArticle = (id) => {
    return (dispatch) => {
      return new Promise((resolve) => {
        axios.delete(`${protocol}//${origin}/api/articles/${id}`, getHeaders())
          .then((response) => {
            dispatch(Notifications.success(delArticleSuccess))
            resolve()
          })
          .catch((error) => {
            console.log(error)
            dispatch(Notifications.error(delArticleError))
            resolve()
          })
      })
    }
  }

  export const getPdf = (id, title, isShort = false) => {
    return (dispatch) => {
      return new Promise((resolve) => {
        axios({ method: 'get',
          url: `${protocol}//${origin}/api/articles/pdf/${id}`,
          responseType: 'blob',
          params: {
            isShort: isShort,
            title: title
          } })
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            let fileName = isShort ? (title + '-short') : title
            link.setAttribute('download', `${fileName}.pdf`)
            document.body.appendChild(link)
            link.click()
            dispatch(response)
            resolve()
          })
          .catch((error) => {
            console.log(error)
            resolve()
          })
      })
    }
  }

export const actions = { getArticles, getArticle, addArticle, updateArticle, getPdf }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_ARTICLES]: (state, action) => {
    return {
      ...state,
      articles: action.data
    }
  },
  [GET_ARTICLE]: (state, action) => {
    return {
      ...state,
      article: action.data
    }
  },
  [UPDATE_TABLE_ARTICLE]: (state, action) => {
    return {
      ...state
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  articles: [],
  article: {}
}

export default function articlesReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/articles.js